import axios from "@/plugins/axios";
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { RapportState } from "./types";
import i18n from "@/plugins/i18n";
import MobileMixin from "@/mixins/mobileMixin";
import store from "../store";

const mobileMixinInstance = new MobileMixin();

export const actions: ActionTree<RapportState, RootState> = {
  async getTracker({ commit }) {
    const user = JSON.parse(localStorage.user);
    try {
      const response = await axios.get("bo/rapport/metrics?id=" + user.id);
      commit("SET_METRICS", response.data.editions);
      return response.data.editions;
    } catch (error) {
      if (error instanceof Error && "response" in error) {
        return Promise.reject(error);
      }
      throw error;
    }
  },
  async getAllReports({ commit }) {
    const user = JSON.parse(localStorage.user);
    try {
      let response;
      if (mobileMixinInstance.isMobile()) {
        response = await axios.get(
          "bo/getResultsData?id=" + user.id + "&language=" + i18n.locale + "&format=PDF"
        );
      } else {
        response = await axios.get(
          "bo/getResultsData?id=" + user.id + "&language=" + i18n.locale
        );
      }
      commit("SET_ALL_REPORTS", response.data);
      return response.data;
    } catch (error) {
      if (error instanceof Error && "response" in error) {
        return Promise.reject(error);
      }
      throw error;
    }
  },
  async checkRapportType({ state }, rapportClassName) {
    const user = JSON.parse(localStorage.user);
    try {
      // tslint:disable-next-line: max-line-length
      const response = await axios.get(
        `bo/getResultsChoices?id=${user.id}&RapportGeneralClassName=${rapportClassName}`
      );
      // console.log(response);
      return response.data;
    } catch (error) {
      if (error instanceof Error && "response" in error) {
        return Promise.reject(error);
      }
      throw error;
    }
  },
  async getExtracteurData({ state }, extracteurData: any) {
    try {
      // tslint:disable-next-line: max-line-length
      const url = `bo/getAllReportsSpecBK?id=${state.userId}&site=${extracteurData.site}&dateDebut=${extracteurData.dateDebut}&dateFin=${extracteurData.dateFin}`;
      const response = await axios.get(url, { responseType: "arraybuffer" });
      // console.log(response);
      return response;
    } catch (error) {
      if (error instanceof Error && "response" in error) {
        return Promise.reject(error);
      }
      throw error;
    }
  },
  async getReport({ state }, format) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    // console.log(state.rapport)
    if (!state.rapport) {
      return { status: 409, message: "NoReportInState" };
    } else {
      // tslint:disable-next-line: max-line-length
      let url = `bo/getReport?id=${userId}&rapportClassName=${state.rapport.typeRapport.className}&typeRapport=${state.rapport.type}&`;
      if (!state.rapport.datesMultiples) {
        url += `dateDebut=${state.rapport.dateDebutEnvoi}&dateFin=${state.rapport.dateFinEnvoi}`;
      } else {
        url += `datefiscales[]=${state.rapport.datesEnvoi}`;
      }
      if (store.state.isGlobal) {
        url += `&trainingMode=false`;
      }
      url += `&operation=VENTE&format=${state.rapport.format}`;
      if (state.rapport.lSites.length === 0) {
        // console.log(JSON.parse(localStorage.sites));
        url += `&sites[]=`;
        for (const site of JSON.parse(localStorage.sites)) {
          url = url + `${site.restaurantId},`;
        }
        url = url.substring(0, url.length - 1);
      }
      if (
        state.rapport.lSites !== undefined &&
        state.rapport.lSites.length > 0
      ) {
        url += `&sites[]=`;
        for (const site of state.rapport.lSites) {
          url = url + `${site.restaurantId},`;
        }
        url = url.substring(0, url.length - 1);
      }
      if (
        state.rapport.lCaisses !== undefined &&
        state.rapport.lCaisses.length > 0
      ) {
        url += `&tpv[]=`;
        const caisses = state.rapport.lCaisses.toString();
        url += caisses;
      }

      if (state.rapport.typeRapport.dttConfig !== undefined) {
        const conf = Object.keys(state.rapport.typeRapport.dttConfig);
        for (const dttconf of conf) {
          if (
            typeof state.rapport.typeRapport.dttConfig[dttconf] === "string"
          ) {
            url =
              url +
              "&" +
              dttconf +
              "=" +
              state.rapport.typeRapport.dttConfig[dttconf];
          } else if (
            typeof state.rapport.typeRapport.dttConfig[dttconf] === "object"
          ) {
            for (const val of state.rapport.typeRapport.dttConfig[dttconf]) {
              url = url + "&" + dttconf + "=" + val;
            }
          }
        }
        url = url + "&merim_format=PDF";
      }

      url = url + `&language=${i18n.locale}`;
      if (state.rapport.trancheHoraire) {
        url +=
          "&trancheHoraire=true&heureDebut=" +
          state.rapport.heureDebut +
          "&heureFin=" +
          state.rapport.heureFin;
      } else {
        url += "&trancheHoraire=false";
      }
      if (state.rapport.vendeur !== undefined && state.rapport.vendeur !== "") {
        // on remplace les virgules par un caractère spécial au cas ou un vendeur contient des virgules dans son nom
        url += "&vendeurs=" + state.rapport.vendeur.replace(",", "__COMMA__");
      }

      if (state.rapport.filtre !== "") {
        url = url + "&filtre=" + state.rapport.filtre;
        if (state.rapport.condition.length > 0) {
          url = url + "&condition=" + state.rapport.condition.map((value) => encodeURIComponent(value)).join(",");
        }
      }
      if (state.rapport.tri !== "") {
        url = url + "&tri=" + state.rapport.tri;
      }
      if (state.rapport.ra !== "") {
        url = url + "&regroupement=" + state.rapport.ra;
      }
      url = url + "&isFilters=" + state.rapport.isfilters;
      // console.log(url);
      try {
        const res = axios
          .get(url, { responseType: "blob" })
          .then((response) => {
            // console.log(response);
            return response;
          });
        return res;
      } catch (error) {
        if (error instanceof Error && "response" in error) {
          return Promise.reject(error);
        }
        throw error;
      }
    }
  },
  async getReportTotal({ state }, format) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    if (!state.rapport) {
      return { status: 409, message: "NoReportInState" };
    } else {
      let url = `bo/getReport?id=${userId}`;
      const urlConfig = {
        id: userId,
        rapportClassName: state.rapport.typeRapport.className,
        typeRapport: state.rapport.type,
        operation: "VENTE",
        trancheHoraire: false,
        format: state.rapport.format,
        language: i18n.locale,
        dateDebut: state.rapport.dateDebutEnvoi,
        dateFin: state.rapport.dateFinEnvoi,
        sites: new Array()
      };

      if (state.rapport.lSites.length === 0) {
        const mesSites = new Array();
        console.log(localStorage.sites);
        for (const site of JSON.parse(localStorage.sites)) {
          mesSites.push(site.restaurantId);
        }
        urlConfig.sites = mesSites;
      }
      if (
        state.rapport.lSites !== undefined &&
        state.rapport.lSites.length > 0
      ) {
        const mesSites = new Array();
        for (const site of state.rapport.lSites) {
          mesSites.push(site.restaurantId);
        }
        url = url.substring(0, url.length - 1);
        urlConfig.sites = mesSites;
      }
      if (
        state.rapport.lCaisses !== undefined &&
        state.rapport.lCaisses.length > 0
      ) {
        url += `&tpv=`;
        const caisses = state.rapport.lCaisses.toString();
        url += caisses;
      }

      if (state.rapport.typeRapport.dttConfig !== undefined) {
        const conf = Object.keys(state.rapport.typeRapport.dttConfig);
        for (const dttconf of conf) {
          if (
            typeof state.rapport.typeRapport.dttConfig[dttconf] === "string"
          ) {
            url =
              url +
              "&" +
              dttconf +
              "=" +
              state.rapport.typeRapport.dttConfig[dttconf];
          } else if (
            typeof state.rapport.typeRapport.dttConfig[dttconf] === "object"
          ) {
            for (const val of state.rapport.typeRapport.dttConfig[dttconf]) {
              url = url + "&" + dttconf + "=" + val;
            }
          }
        }
        url = url + "&merim_format=PDF";
      }
      if (state.rapport.trancheHoraire) {
        url +=
          "&trancheHoraire=true&heureDebut=" +
          state.rapport.heureDebut +
          "&heureFin=" +
          state.rapport.heureFin;
      } else {
        url += "&trancheHoraire=false";
      }
      if (state.rapport.vendeur !== undefined && state.rapport.vendeur !== "") {
        // on remplace les virgules par un caractère spécial au cas ou un vendeur contient des virgules dans son nom
        url += "&vendeurs=" + state.rapport.vendeur.replace(",", "__COMMA__");
      }

      if (state.rapport.filtre !== "") {
        url = url + "&filtre=" + state.rapport.filtre;
        if (state.rapport.condition.length > 0) {
          url = url + "&condition=" + state.rapport.condition.map((value) => encodeURIComponent(value)).join(",");
        }
      }
      if (state.rapport.ra !== "") {
        url = url + "&regroupement=" + state.rapport.ra;
      }
      if (state.rapport.tri !== "") {
        url = url + "&tri=" + state.rapport.tri;
      }
      url = url + "&isFilters=" + state.rapport.isfilters;
      try {
        const res = axios
          .post(url, urlConfig, { responseType: "blob" })
          .then((response) => {
            return response;
          });
        return res;
      } catch (error) {
        if (error instanceof Error && "response" in error) {
          return Promise.reject(error);
        }
        throw error;
      }
    }
  },
  async getReportIndividuel({ state }, site) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    if (!state.rapport) {
      return { status: 409, message: "NoReportInState" };
    } else {
      // tslint:disable-next-line: max-line-length
      let url = `bo/getReport?id=${userId}&rapportClassName=${state.rapport.typeRapport.className}&typeRapport=${state.rapport.type}&dateDebut=${state.rapport.dateDebutEnvoi}&dateFin=${state.rapport.dateFinEnvoi}&operation=VENTE&format=${state.rapport.format}&sites[]=${site}`;
      if (
        state.rapport.lCaisses !== undefined &&
        state.rapport.lCaisses.length > 0
      ) {
        url += `&tpv[]=`;
        const caisses = state.rapport.lCaisses.toString();
        url += caisses;
      }

      if (state.rapport.typeRapport.dttConfig !== undefined) {
        const conf = Object.keys(state.rapport.typeRapport.dttConfig);
        for (const dttconf of conf) {
          if (
            typeof state.rapport.typeRapport.dttConfig[dttconf] === "string"
          ) {
            url =
              url +
              "&" +
              dttconf +
              "=" +
              state.rapport.typeRapport.dttConfig[dttconf];
          } else if (
            typeof state.rapport.typeRapport.dttConfig[dttconf] === "object"
          ) {
            for (const val of state.rapport.typeRapport.dttConfig[dttconf]) {
              url = url + "&" + dttconf + "=" + val;
            }
          }
        }
        url = url + "&merim_format=PDF";
      }
      if (state.rapport.trancheHoraire) {
        url +=
          "&trancheHoraire=true&heureDebut=" +
          state.rapport.heureDebut +
          "&heureFin=" +
          state.rapport.heureFin;
      } else {
        url += "&trancheHoraire=false";
      }
      if (state.rapport.vendeur !== undefined && state.rapport.vendeur !== "") {
        // on remplace les virgules par un caractère spécial au cas ou un vendeur contient des virgules dans son nom
        url += "&vendeurs=" + state.rapport.vendeur.replace(",", "__COMMA__");
      }

      if (state.rapport.filtre !== "") {
        url = url + "&filtre=" + state.rapport.filtre;
        if (state.rapport.condition.length > 0) {
          url = url + "&condition=" + state.rapport.condition.map((value) => encodeURIComponent(value)).join(",");
        }
      }
      if (state.rapport.ra !== "") {
        url = url + "&regroupement=" + state.rapport.ra;
      }
      if (state.rapport.tri !== "") {
        url = url + "&tri=" + state.rapport.tri;
      }
      url = url + "&isFilters=" + state.rapport.isfilters;
      // console.log(url);
      try {
        return axios.get(url, { responseType: "blob" }).then((response) => {
          // console.log(response);
          return response;
        });
      } catch (error) {
        if (error instanceof Error && "response" in error) {
          return Promise.reject(error);
        }
        throw error;
      }
    }
  },
  async getFilter({ state }, filterData: any) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const url = `bo/getGroupements?id=${userId}&rapportGeneralClassName=${filterData.rapportGeneralClassName}&filtre=${filterData.filter}&restaurantId=${filterData.restaurantId}&dateDebut=${filterData.dateDebut}&dateFin=${filterData.dateFin}`;
    return await axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  updateRapport({ commit }, rapport) {
    commit("UPDATE_RAPPORT", rapport);
  },
  addFavoris({ commit }, favoris) {
    commit("ADD_FAVORIS", favoris);
  },
  removeFavoris({ commit }, favoris) {
    // console.log("je remove", favoris);
    commit("REMOVE_FAVORIS", favoris);
  },
  updateFavoris({ commit }, favoris) {
    commit("SET_FAVORIS", favoris);
  },
  updateOneFavoris({ state, commit }, oneFav) {
    commit("UPDATE_FAVORIS", oneFav);
  },
  updateSelectedFavoris({ commit, state }, favoris) {
    commit("UPDATE_SELECTED_FAVORIS", favoris);
    commit("UPDATE_IS_NEW", false);
  },
  updateNewFavoris({ commit, state }, favoris) {
    // console.log(favoris);
    commit("UPDATE_IS_NEW", true);
    commit("UPDATE_NEW_FAV", favoris);
    commit("UPDATE_SELECTED_FAVORIS", undefined);
  },
};
